import { StyleSheet, TouchableOpacity } from 'react-native';
import { useTranslation } from 'react-i18next';

import { colors, spacing, Text } from '@pletly/ui';
import { openBookApp } from '%services/book';
import BookIcon from './open-book.svg';

export const NewBookContent = () => {
	const { t } = useTranslation();

	return (
		<TouchableOpacity style={styles.root} onPress={openBookApp}>
			<BookIcon />
			<Text category="h5" style={styles.title}>
				{t('post.book-post.new-book')}
			</Text>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	root: {
		width: 343,
		height: 340,
		backgroundColor: colors.primary700,
		justifyContent: 'center',
		alignItems: 'center',
		alignSelf: 'center',
		marginVertical: spacing(),
	},
	title: { color: colors.white, textTransform: 'uppercase', padding: spacing() },
});
